import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { createNumberMask } from 'text-mask-addons/dist/textMaskAddons';
import { PullEvent } from '../../../model/PullEvent';
import { BitfinexCurrencyEnabledChange } from '../../../model/BitfinexCurrencyEnabledChange';
import { animate, query, state, style, transition, trigger } from '@angular/animations';
import { RecalculateTargetInUSDEvent } from '../../../model/RecalculateTargetInUSDEvent';
import { RecalculateTargetInGivenCurrencyEvent } from '../../../model/RecalculateTargetInGivenCurrencyEvent';
import { Exchange, EXCHANGES } from '../../../model/constants';
import { Subscription } from 'rxjs';
import { PositionService } from '../../service/position.service';
import { Wallet } from '../../../model/Wallet';
import { Pos } from '../../../model/Pos';
import { AccountsConfig } from '../../../model/AccountsConfig';
import { initApplicationSelector } from '../../../store/Application/ApplicationSelector';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../../../store/Application/ApplicationReducer';
import { ServerConfig } from '../../../model/ServerConfig';
import { EnvironmentType } from '../../../model/EnvironmentType';
import { EnableAllCurrencyForAccountEvent } from '../../../model/EnableAllCurrencyForAccountEvent';
import { DisableAllCurrencyForAccountEvent } from '../../../model/DisableAllCurrencyForAccountEvent';
import { EmptyTargetEvent } from '../../../model/EmptyTargetEvent';
import { NullTargetEvent } from '../../../model/NullTargetEvent';
import { RecalculateTargetEvent } from '../../../model/RecalculateTargetEvent';
import { Json } from '../../../model/Json';
import { PERMISSION, UserClient } from '@clearing-hub/common';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-position',
  templateUrl: './position.component.html',
  styleUrls: ['./position.component.scss'],
  animations: [
    trigger('signalChange', [
      state('running', style({
      })),
      state('stopped', style({
      })),
      transition('stopped => running',
        query('.ng-select-container',  [
            animate('0.3s', style({ background: '#007bff' })),
            animate('0.3s', style({ background: 'white' }))
            // animate('1s', style({ background: "blue" }))
          ], {optional: true}
        )
      )
    ]),
    trigger('flipState', [
      state('true', style({
        transform: 'rotateY(179deg)'
      })),
      state('false', style({
        transform: 'rotateY(0)'
      })),
      transition('true => false', animate('500ms ease-out')),
      transition('false => true', animate('500ms ease-in'))
    ])
  ]
})
export class PositionComponent implements OnInit, OnChanges, OnDestroy {

  @Input()
  currentUser: UserClient;

  @Input()
  wallet: Wallet;

  @Input()
  item: Pos;

  @Input()
  accountsConfig: AccountsConfig;

  @Input()
  target: any = {};

  @Input()
  targetInUSD: any = {};

  @Input()
  selectedAccounts: any[] = [];

  @Input()
  pushEnabled = true;

  @Input()
  exchangeName: any;

  @Input()
  showOnlyBitfinexEnabledAccounts = false;

  @Input()
  isBitfinexTargetEnabled: Json<string, Json<number, Json<string, boolean>>>;

  @Input()
  isSelectorDisabled: Json<string, Json<number, boolean>>;

  @Output()
  recalculateTargetEvent = new EventEmitter<RecalculateTargetEvent>();

  @Output()
  pushEvent = new EventEmitter<Pos>();

  @Output()
  nullTargetEvent = new EventEmitter<NullTargetEvent>();

  @Output()
  emptyTargetEvent = new EventEmitter<EmptyTargetEvent>();

  @Output()
  pullEvent = new EventEmitter<PullEvent>();

  @Output()
  bitfinexCurrencyEnabledChangeEvent = new EventEmitter<BitfinexCurrencyEnabledChange>();

  @Output()
  enableAllCurrencyForAccountEvent = new EventEmitter<EnableAllCurrencyForAccountEvent>();

  @Output()
  disableAllCurrencyForAccountEvent = new EventEmitter<DisableAllCurrencyForAccountEvent>();

  @Output()
  recalculateTargetInUSDEvent = new EventEmitter<RecalculateTargetInUSDEvent>();

  @Output()
  recalculateTargetInGivenCurrencyEvent = new EventEmitter<RecalculateTargetInGivenCurrencyEvent>();

  currencies: Array<string>;

  EXCHANGES = EXCHANGES;

  abosAccountRatioDropdown = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  public mask = [];

  flipped: Json<string, boolean> = {};

  allEnabledCheckboxStateForAccount: Json<string, Json<string | number, boolean>>;

  PERMISSION_ENUM = PERMISSION;

  subscriptions: Array<Subscription> = new Array<Subscription>();

  config: ServerConfig;
  EnvironmentType = EnvironmentType;

  constructor(private positionService: PositionService,
              private readonly applicationStore: Store<ApplicationState>) {
  }

  toggleFlip(abosAccountId) {
    this.flipped[abosAccountId] = !this.flipped[abosAccountId];
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  isNotDefinedOrNull(value: any) {
    return value !== undefined && value !== null;
  }

  ngOnInit(): void {
    this.applicationStore.select(initApplicationSelector).subscribe((config) => {
      this.config = config;
    });
    // this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.currencies = Object.keys(this.item.ccyPositions);
    this.mask = createNumberMask({
      prefix: '',
      suffix: '',
      allowDecimal: true,
      decimalLimit: 6,
      decimalSymbol: '.',
      includeThousandsSeparator: true,
      allowLeadingZeroes: true,
      allowNegative: true,
      integerLimit: 13
    });

    // if (this.exchangeName === EXCHANGES.bitfinex) {
    //   this.allEnabledCheckboxStateForAccount = {};
    //   this.wallet.positions.forEach(item => {
    //     const keysForAccount = Object.keys(this.isBitfinexTargetEnabled[item.account.abosAccountId]);
    //     if (keysForAccount.filter(ccy => this.isBitfinexTargetEnabled[item.account.abosAccountId][ccy]).length === Object.keys(keysForAccount).length) {
    //       this.allEnabledCheckboxStateForAccount[item.account.abosAccountId] = true;
    //     } else {
    //       this.allEnabledCheckboxStateForAccount[item.account.abosAccountId] = false;
    //     }
    //   });
    // }
    // this.initUsage();

    if (this.exchangeName === EXCHANGES.bitfinex) {
      this.allEnabledCheckboxStateForAccount = {};
      this.wallet.positions.filter(p => p.exchange !== Exchange.BITFINEX_SWAP).forEach(item => {
        if (!this.allEnabledCheckboxStateForAccount[item.account.abosAccountId]) {
          this.allEnabledCheckboxStateForAccount[item.account.abosAccountId] = {};
        }
        const keysForAccount = Object.keys(this.isBitfinexTargetEnabled[item.account.abosAccountId][item.account.bitfinexAccountId]);
        if (keysForAccount.filter(ccy => this.isBitfinexTargetEnabled[item.account.abosAccountId][ccy]).length === keysForAccount.length) {
          this.allEnabledCheckboxStateForAccount[item.account.abosAccountId][item.account.bitfinexAccountId] = true;
        } else {
          this.allEnabledCheckboxStateForAccount[item.account.abosAccountId][item.account.bitfinexAccountId] = false;
        }
      });

      this.subscriptions.push(this.positionService.allAccountStateChangeEvent.subscribe((ccysState: boolean) => {
        Object.keys(this.allEnabledCheckboxStateForAccount).forEach(abosAccId => {
          Object.keys(this.allEnabledCheckboxStateForAccount[abosAccId]).forEach(bfxAccId => {
            this.allEnabledCheckboxStateForAccount[abosAccId][bfxAccId] = ccysState;
          });
        });
      }));
      this.subscriptions.push(this.positionService.disableAllCcyForAccountEvent.subscribe((event) => {
        if (event.bitfinexAccountId) {
          this.allEnabledCheckboxStateForAccount[event.abosAccountId][event.bitfinexAccountId] = false;
        } else {
          Object.keys(this.allEnabledCheckboxStateForAccount[event.abosAccountId]).forEach(bfxAccId => {
            this.allEnabledCheckboxStateForAccount[event.abosAccountId][bfxAccId] = false;
          });
        }
      }));
      this.subscriptions.push(this.positionService.enableAllCcyForAccountEvent.subscribe((event) => {
        this.allEnabledCheckboxStateForAccount[event.abosAccountId][event.bitfinexAccountId] = true;
      }));
    }

    if (this.exchangeName === EXCHANGES.bitfinexSwap) {
      this.allEnabledCheckboxStateForAccount = {};
      this.wallet.positions.filter(p => this.accountsConfig.bitfinexSwap.includes(Number(p.account.bitfinexAccountId))).forEach(item => {
        const bfxId = Number(item.account.bitfinexAccountId);
        if (!this.allEnabledCheckboxStateForAccount[bfxId]) {
          this.allEnabledCheckboxStateForAccount[bfxId] = {};
        }
        const keysForAccount = Object.keys(this.isBitfinexTargetEnabled[bfxId]);
        if (keysForAccount.filter(ccy => this.isBitfinexTargetEnabled[bfxId][ccy]).length === Object.keys(keysForAccount).length) {
          this.allEnabledCheckboxStateForAccount[bfxId][bfxId] = true;
        } else {
          this.allEnabledCheckboxStateForAccount[bfxId][bfxId] = false;
        }
      });

      this.subscriptions.push(this.positionService.allAccountStateChangeEvent.subscribe((ccysState: boolean) => {
        Object.keys(this.allEnabledCheckboxStateForAccount).forEach(abosAccId => {
          Object.keys(this.allEnabledCheckboxStateForAccount[abosAccId]).forEach(bfxAccId => {
            this.allEnabledCheckboxStateForAccount[abosAccId][bfxAccId] = ccysState;
          });
        });
      }));
      this.subscriptions.push(this.positionService.disableAllCcyForAccountEvent.subscribe((event) => {
        this.allEnabledCheckboxStateForAccount[event.abosAccountId][event.bitfinexAccountId] = false;
      }));
      this.subscriptions.push(this.positionService.enableAllCcyForAccountEvent.subscribe((event) => {
        this.allEnabledCheckboxStateForAccount[event.abosAccountId][event.bitfinexAccountId] = true;
      }));
    }
  }

  calculateDifferences(abosAccountId: string, bitfinexAccountId: number) {
    this.recalculateTargetEvent.emit({
      abosAccountId,
      bitfinexAccountId
    });
  }

  pushData(pos: Pos) {
    this.pushEvent.emit(pos);
  }

  pull(abosAccountId: any, bitfinexAccountId: number) {
    this.pullEvent.emit(new PullEvent(abosAccountId, bitfinexAccountId, this.exchangeName));
  }

  nullTarget(abosAccountId: string, bitfinexAccountId: number) {
    this.nullTargetEvent.emit({
      abosAccountId,
      bitfinexAccountId
    });
  }

  emptyTarget(abosAccountId: string, bitfinexAccountId: number) {
    this.emptyTargetEvent.emit({
      abosAccountId,
      bitfinexAccountId
    });
  }

  emitBitfinexCurrencyEnabledChange(event, abosAccountId: any, bitfinexAccountId: number, currency: string, isSwap: boolean) {
    if (!event) {
      this.allEnabledCheckboxStateForAccount[abosAccountId][bitfinexAccountId] = false;
    }
    let isAllEnabled = true;
    Object.keys(this.isBitfinexTargetEnabled[abosAccountId][bitfinexAccountId]).forEach(ccy => {
      if (!this.isBitfinexTargetEnabled[abosAccountId][bitfinexAccountId][ccy]) {
        isAllEnabled = false;
      }
    });

    if (isAllEnabled) {
      this.allEnabledCheckboxStateForAccount[abosAccountId][bitfinexAccountId] = true;
    }

    console.log(new BitfinexCurrencyEnabledChange(abosAccountId, bitfinexAccountId, currency, event, isSwap));
    this.bitfinexCurrencyEnabledChangeEvent.emit(new BitfinexCurrencyEnabledChange(abosAccountId, Number(bitfinexAccountId), currency, event, isSwap));
  }

  enableAllCurrencyForAccount(abosAccountId: any, isSwap: boolean, bitfinexAccountId: number) {
    this.allEnabledCheckboxStateForAccount[abosAccountId][bitfinexAccountId] = true;
    this.enableAllCurrencyForAccountEvent.emit({abosAccountId, isSwap, bitfinexAccountId});
  }

  disableAllCurrencyForAccount(abosAccountId: any, isSwap: boolean, bitfinexAccountId: number) {
    this.allEnabledCheckboxStateForAccount[abosAccountId][bitfinexAccountId] = false;
    this.disableAllCurrencyForAccountEvent.emit({abosAccountId, isSwap, bitfinexAccountId});
  }

  // getNumberOfEnabledCCY(abosAccountId: string) {
  //   let numberOfDisabledCurrency = 0;
  //   Object.keys(this.isBitfinexTargetEnabled[abosAccountId]).forEach(ccy => {
  //     if (!this.isBitfinexTargetEnabled[abosAccountId][ccy]) {
  //       numberOfDisabledCurrency++;
  //     }
  //     this.isBitfinexTargetEnabled[abosAccountId][ccy] = true;
  //   });
  //   return numberOfDisabledCurrency;
  // }

  recalculateTargetInUSD(event: number, abosAccountId: string, bitfinexAccountId: number, currency: string) {
    this.recalculateTargetInUSDEvent.emit(new RecalculateTargetInUSDEvent(abosAccountId, bitfinexAccountId, currency, event));
  }

  recalculateTargetGivenCurrency(event: number, abosAccountId: string, bitfinexAccountId: number, currency: string) {
    this.recalculateTargetInGivenCurrencyEvent.emit(new RecalculateTargetInGivenCurrencyEvent(abosAccountId, bitfinexAccountId, currency, event));
  }

  flip(abosAccountId: string) {
    this.flipped[abosAccountId] = !this.flipped[abosAccountId];
  }

  getMappedCurrency(ccy: string): string {
    let mappedCcy = null;
    if (!this.wallet.currencyMappings) {
      return ccy;
    }
    Object.keys(this.wallet.currencyMappings[Exchange.BITFINEX.toLowerCase()]).forEach(item => {
      if (this.wallet.currencyMappings[Exchange.BITFINEX.toLowerCase()][item] === ccy) {
        mappedCcy = item;
      }
    });
    return mappedCcy ? mappedCcy : ccy;
  }

  handle(event, abosAccountId: any, isSwap: boolean, bitfinexAccountId: number) {
    if (event) {
      this.enableAllCurrencyForAccount(abosAccountId, isSwap, bitfinexAccountId);
    } else {
      this.disableAllCurrencyForAccount(abosAccountId, isSwap, bitfinexAccountId);
    }
  }

  positionsComparator2(pos: Pos, a: string, b: string) {
    if (this.isNotDefinedOrNull(pos.ccyPositions[a].bitfinexPosition) && this.isNotDefinedOrNull(pos.ccyPositions[b].bitfinexPosition)) {
      // return -1;
      return a.localeCompare(b);
    }
    if (!this.isNotDefinedOrNull(pos.ccyPositions[a].bitfinexPosition) && !this.isNotDefinedOrNull(pos.ccyPositions[b].bitfinexPosition)) {
      // if (this.isNotDefinedOrNull(pos.ccyPositions[a].tradePosition) && this.isNotDefinedOrNull(pos.ccyPositions[a].tradePosition)) {
      //
      // }
      return a.localeCompare(b);
      // return 0;
    }
    if (this.isNotDefinedOrNull(pos.ccyPositions[a].bitfinexPosition) && !this.isNotDefinedOrNull(pos.ccyPositions[b].bitfinexPosition)) {
      return -1;
    }
    if (!this.isNotDefinedOrNull(pos.ccyPositions[a].bitfinexPosition) && this.isNotDefinedOrNull(pos.ccyPositions[b].bitfinexPosition)) {
      return 1;
    }
    // return 0;
    return a.localeCompare(b);
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  // getPositionForCcy(item: Pos, ccy: string) {
  //   const mapped = this.getMappedCurrency(ccy);
  //   const asd = item.ccyPositions[mapped];
  //   if (!asd) {
  //     return 0;
  //   }
  //
  //   return asd.bitfinexPosition;
  // }

  getAccountId(pos: Pos) {
    if (this.exchangeName === Exchange.BITFINEX_SWAP) {
      return pos.account.bitfinexAccountId;
    }
    return pos.account.abosAccountId;
  }
}
